// client/lib/fbpixel.ts
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
    _pixelLoaded?: boolean;
  }
}

type FbqFn = (...args: any[]) => void;

export function loadPixelOnce() {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;

  const n: FbqFn & { queue?: any[]; loaded?: boolean; version?: string; push?: any } = function () {
    // @ts-expect-error
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue!.push(arguments);
  } as any;

  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  window.fbq = n;

  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
}

export function initPixel(pixelId: string, advancedMatching?: Record<string, any>) {
  loadPixelOnce();
  window.fbq?.('init', pixelId, advancedMatching);
  window._pixelLoaded = true;
}

export function track(eventName: string, params?: Record<string, any>) {
  window.fbq?.('track', eventName, params);
}

export function trackCustom(eventName: string, params?: Record<string, any>) {
  window.fbq?.('trackCustom', eventName, params);
}

export function initAndTrackOnce(
  pixelId: string,
  eventName: string,
  params?: Record<string, any>,
  advancedMatching?: Record<string, any>
) {
  initPixel(pixelId, advancedMatching);
  track(eventName, params);
}
